
import { defineComponent } from "vue";
import SessionService from "@/services/cache/session-state";
import AuthService from "@/services/api/auth.service";
import { toast } from "vue3-toastify";
import Title from "@/components/layout/title.vue";

export default defineComponent({
  components: {
    Title: Title,
  },
  data() {
    return {
      platformUrl: "" as string | null,
      apiToken: "" as string | null,
      submitted: false,
    };
  },
  methods: {
    async saveSetup() {
      this.submitted = true;
      if (this.platformUrl && this.apiToken) {
        const isValid = await AuthService.isAuthenticated(
          this.platformUrl,
          this.apiToken,
        );

        if (!isValid) {
          toast.error("Invalid credentials, please check connection!");

          return;
        }

        // For simplicity instead of using Vuex, we will use SessionService to store the state in local storage
        SessionService.saveState(this.platformUrl, this.apiToken);

        toast.info("Connection succeeded!");

        setTimeout(() => {
          this.$router.push("/product");
        }, 1000);
      }
    },
  },
  created() {
    if (!SessionService.isSetupValid()) {
      SessionService.clearState();
      return;
    }

    this.platformUrl = SessionService.platformUrl;
    this.apiToken = SessionService.apiToken;
  },
});
